import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocalstorageService } from '@services/localstorage.service';
import { AuthService } from 'app/features/services/auth.service';
import { LOCALSTORAGE } from '../constants/constants';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const localStorageService = inject(LocalstorageService);

  const token = localStorageService.getItem(LOCALSTORAGE.TOKEN);
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  return next(req);
};
